import type { ISerializationPort } from "@src/domain/ports";
import { LocalStorageManager } from "@src/infrastructure/services/localstorage";
import {
  LOCAL_STORAGE_CLEAR_ERROR_CONFIG,
  LOCAL_STORAGE_DELETE_ERROR_CONFIG,
  StorageAdapterBase,
} from "../storage/StorageAdapterBase";

export const DEFAULT_STORAGE_PREFIX = "dm-admin-app";

export class LocalStorageAdapter extends StorageAdapterBase {
  constructor(serializer: ISerializationPort, prefix: string = DEFAULT_STORAGE_PREFIX) {
    super(
      new LocalStorageManager(prefix),
      serializer,
      LOCAL_STORAGE_DELETE_ERROR_CONFIG,
      LOCAL_STORAGE_CLEAR_ERROR_CONFIG
    );
  }
}
